<template>
    <div class="sales-report-page">
    
        <div v-if="!isAuthenticated" class="password-overlay">
            <div class="password-modal">
                <h4 class="mb-3">🔒 Enter Password to View Report</h4>
                <input 
                    type="password" 
                    v-model="enteredPassword" 
                    @keyup.enter="verifyPassword"
                    class="form-control mb-3" 
                    placeholder="Password"
                />
                <button 
                    @click="verifyPassword" 
                    class="btn btn-primary btn-block"
                >
                    Access Report
                </button>
                <p v-if="authError" class="text-danger mt-2">{{ authError }}</p>
            </div>
        </div>
    
        <div v-show="isAuthenticated">
            <h2 class="page-title mb-4">Sales Report</h2>
        
            <div class="card-wrapper p-2">
                <div class="d-flex justify-content-between align-items-center mb-4">
        
                    <div class="input-group search-box mr-1">
                        <input type="text" class="form-control" placeholder="Search..." />
                    </div>
        
                    <div style="min-width: 300px;">
                        <div v-if="isBulananActive">
                            <select class="form-control custom-select" v-model="selectedMonth" @change="GetListReport">
                                <option v-for="(m, index) in monthList" :key="index" :value="m.value">
                                    {{ m.label }}
                                </option>
                            </select>
                        </div>
                        <div v-if="isMingguanActive" class="d-flex align-items-center justify-content-end mb-3">
        
                            <button class="btn btn-light mr-2" @click="previousWeek">
                                                                    &lt; Prev
                                                                </button>
        
                            <div class="font-weight-bold mx-2">
                                {{ weekLabel }}
                            </div>
        
                            <button class="btn btn-light" @click="nextWeek">
                                                                    Next &gt;
                                                                </button>
        
                        </div>
                        <div v-if="activeFilter === 'harian'" class="ml-2">
                            <input type="date" class="form-control" v-model="selectedDate" @change="GetListReport" />
                        </div>
        
                        <div v-if="activeFilter === 'tahun'" class="ml-2">
                            <select class="form-control custom-select" v-model="selectedYear" @change="GetListReport">
                                    <option v-for="y in yearList" :key="y">{{ y }}</option>
                                </select>
                        </div>
        
                        <div v-if="activeFilter === 'custom'" class="d-flex">
        
                            <input type="date" class="form-control mr-2" v-model="startDate" @change="GetListReport" style="min-width: 150px;" />
        
                            <input type="date" class="form-control" v-model="endDate" @change="GetListReport" style="min-width: 150px;" />
        
                        </div>
                    </div>
        
                </div>
        
                <div class="time-filter d-flex mb-4 flex-wrap">
        
                    <button class="btn mr-2 m-1" :class="activeFilter === 'harian' ? 'bg-007CEF text-white' : 'btn-light'" @click="activateHarian">
                                                            Harian
                                                        </button>
        
                    <button class="btn mr-2 m-1" :class="activeFilter === 'mingguan' ? 'bg-007CEF text-white' : 'btn-light'" @click="activateMingguan">
                                                            Mingguan
                                                        </button>
        
                    <button class="btn mr-2 m-1" :class="activeFilter === 'bulanan' ? 'bg-007CEF text-white' : 'btn-light'" @click="activateBulanan">
                                                            Bulanan
                                                        </button>
        
                    <button class="btn mr-2 m-1" :class="activeFilter === 'tahun' ? 'bg-007CEF text-white' : 'btn-light'" @click="activateTahun">
                                                            Tahun
                                                        </button>
        
                    <button class="btn m-1" :class="activeFilter === 'custom' ? 'bg-007CEF text-white' : 'btn-light'" @click="activateCustom">
                                                            Custom
                                                        </button>
        
                </div>
        
                <div class="chart-box mb-4">
                    <canvas id="salesChart"></canvas>
                </div>
        
                <div class="text-center font-weight-bold">
                    Jumlah Nilai
                    <div class="text-primary" style="font-size: 20px;">RM {{ totalSalesValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// Define the required password here
const ACCESS_PASSWORD = "Flyhigh192077**";

export default {
    name: "SalesReportPage",
    data() {
        return {
            chart: null,
            report: [],

            // --- AUTHENTICATION DATA ---
            isAuthenticated: false,
            enteredPassword: '',
            authError: '',
            // ---------------------------

            isBulananActive: true,
            monthList: [],
            isMingguanActive: false,

            currentWeek: null,
            selectedWeek: null,
            currentYear: null,
            activeFilter: "bulanan",

            // DAILY FILTER
            selectedDate: new Date().toISOString().substr(0, 10), 

            selectedYear: new Date().getFullYear(),
            yearList: [],

            selectedMonth: new Date().getMonth() + 1, 
            selectedMonthYear: new Date().getFullYear(),

            startDate: null,
            endDate: null,
        };
    },
    computed: {
        totalSalesValue() {
            if (!this.report || this.report.length === 0) {
                return 0;
            }

            const total = this.report.reduce((sum, item) => {
                return sum + (Number(item.TotalAmount) || 0);
            }, 0);

            return total;
        },
        isCurrentWeek() {
            return (
                this.selectedWeek === this.currentWeek &&
                this.currentYear === new Date().getFullYear()
            );
        },

        weekLabel() {
            return `Week ${this.selectedWeek}, ${this.currentYear}`;
        }
    },
    async mounted() {
        // --- AUTHENTICATION CHECK ---
        // 1. Check if the user is generally authenticated (UserAuth)
       
        let savedAuth = localStorage.getItem("affiliateReportAuth");

if (savedAuth === "true") {
    this.isAuthenticated = true;
    this.generateMonthList();
            this.generateYearList();

            this.GetListReport();
            
    return;
}

// Still need login check for app
let isAuth = await this.UserAuth();
if (!isAuth) this.GoToLogin();
    },

    methods: {
       
        verifyPassword() {
            this.authError = '';

            if (this.enteredPassword === ACCESS_PASSWORD) {
                this.isAuthenticated = true;
                this.enteredPassword = '';

                // 🔥 Save auth state so refresh won't require re-entering password
                localStorage.setItem("affiliateReportAuth", "true");

                this.GetListReport();
            } else {
                this.authError = 'Incorrect password. Please try again.';
            }
        },
        // ----------------------------------

        // Convert API data to chart format
        renderChart() {
            // ... (rest of renderChart logic remains the same)
            const ctx = document.getElementById("salesChart");

            if (this.chart) this.chart.destroy();

            let labels = [];
            let values = [];
            let labelTitle = "";

            // -----------------------------
            // 1️⃣ MONTHLY CHART
            // -----------------------------
            if (this.activeFilter === "bulanan") {
                labelTitle = "Jumlah Bulanan";

                const monthNames = [
                    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
                    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
                ];

                const monthlyData = {};

                for (let i = 1; i <= 12; i++) monthlyData[i] = 0;

                this.report.forEach(r => {
                    // Assuming this logic is correct for monthly data view
                    // This section seems to have mixed logic in the original code, but 
                    // I'll keep the monthly data processing logic for now:
                    // monthlyData[r.Month] = r.TotalAmount;
                });
                
                // If 'bulanan' is active, the labels should be days if grouping by day
                // or months if grouping by year. Since the activeFilter is 'bulanan', 
                // the `GetListReport` URL suggests grouping by day within a month.
                
                labels = this.report.map(r => {
                    let d = new Date(r.Date);
                    return d.getDate(); // day number (1–31)
                });
                values = this.report.map(r => Number(r.TotalAmount) || 0);
            }

            // -----------------------------
            // 2️⃣ WEEKLY CHART
            // -----------------------------
            if (this.activeFilter === "mingguan") {
                labelTitle = "Jumlah Mingguan";

                labels = this.report.map(r => {
                    const d = new Date(r.Date);
                    return d.toLocaleDateString("en-US", { day: "2-digit", month: "short" });
                });

                values = this.report.map(r => r.TotalAmount);
            }

            // -----------------------------
            // 3️⃣ DAILY CHART
            // -----------------------------
            if (this.activeFilter === "harian") {
                labelTitle = "Jumlah Harian";

                // Format hour: always show HH:00
                labels = this.report.map(r => {
                    let hour = r.Hour.toString().padStart(2, "0");
                    return `${hour}:00`;
                });

                values = this.report.map(r => r.TotalAmount);
            }

            // -----------------------------
            // 4️⃣ YEARLY
            // -----------------------------
            if (this.activeFilter === "tahun") {
                labelTitle = "Jumlah Tahunan";

                const monthlyTotals = {};
                
                // Use a proper month order list for labels
                const monthOrder = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                
                monthOrder.forEach(month => monthlyTotals[month] = 0);

                this.report.forEach(r => {
                    let d = new Date(r.Date);
                    let month = d.toLocaleString("en-US", { month: "short" });

                    monthlyTotals[month] += Number(r.TotalAmount) || 0;
                });

                labels = monthOrder; 
                values = monthOrder.map(month => monthlyTotals[month]);
            }

            // -----------------------------
            // 5️⃣ CUSTOM
            // -----------------------------
            if (this.activeFilter === "custom") {
                labelTitle = "Custom Range";

                labels = this.report.map(r => {
                    let d = new Date(r.Date);
                    return d.toISOString().substr(0, 10); // ← only YYYY-MM-DD
                });

                values = this.report.map(r => Number(r.TotalAmount) || 0);
            }
            // -----------------------------
            // Draw chart according to filter
            // -----------------------------
            this.chart = new Chart(ctx, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [{
                        label: labelTitle,
                        data: values,
                        backgroundColor: "#2F80ED",
                        borderColor: "#2F80ED",
                        borderWidth: 1,
                        borderRadius: 6
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: true },
                        tooltip: { enabled: true }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            min: 0,
                            suggestedMax: 10 // force bar to appear
                        }
                    }
                }
            });
        },
        // Fetch API data then draw chart
        async GetListReport() {
             // Only fetch data if authenticated
            if (!this.isAuthenticated) {
                return; 
            }
            
            try {
                let url = "";

                if (this.activeFilter === "bulanan") {
                    url = `${this.$GetTotalAmountPerMonthGroupDate}?month=${this.selectedMonth}&year=${this.selectedMonthYear}`;
                } else if (this.activeFilter === "mingguan") {
                    url = `${this.$GetTotalAmountPerWeekGroupDate}?week=${this.selectedWeek}&year=${this.currentYear}`;
                } else if (this.activeFilter === "harian") {
                    url = `${this.$GetTotalAmountPerDateGroupHour}?date=${this.selectedDate}`;
                } else if (this.activeFilter === "tahun") {
                    url = `${this.$GetTotalAmountPerYearGroupDate}?year=${this.selectedYear}`;
                } else if (this.activeFilter === "custom") {
                    url = `${this.$GetTotalAmountCustomDate}?startDate=${this.startDate}&endDate=${this.endDate}`;
                }

                const response = await this.$API.get(url);

                if (response.status === 200 && response.data) {
                    this.report = response.data;

                    this.$nextTick(() => this.renderChart());
                }

            } catch (err) {
                console.error("Error loading report:", err);
            }
        },

        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/login") {
                this.$router.push({
                    path: "/login",
                    query: { targetUrl: this.$router.currentRoute.fullPath }
                });
            }
        },
        generateMonthList() {
            const monthNames = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            this.monthList = monthNames.map((name, index) => ({
                value: index + 1, // 1–12
                label: `${name} ${new Date().getFullYear()}`
            }));
        },
        initWeek() {
            const today = new Date();

            const oneJan = new Date(today.getFullYear(), 0, 1);
            const numberOfDays = Math.floor((today - oneJan) / (24 * 60 * 60 * 1000));
            const week = Math.ceil((numberOfDays + oneJan.getDay() + 1) / 7);

            this.currentWeek = week;
            this.selectedWeek = week;
            this.currentYear = today.getFullYear();
        },
        previousWeek() {
            if (this.selectedWeek === 1) {
                this.selectedWeek = 52;
                this.currentYear--;
            } else {
                this.selectedWeek--;
            }

            this.GetListReport();
        },

        nextWeek() {
            this.selectedWeek++;

            if (this.selectedWeek > 52) {
                this.selectedWeek = 1;
                this.currentYear++;
            }

            this.GetListReport();
        },
        activateHarian() {
            this.activeFilter = "harian";
            this.isBulananActive = false;
            this.isMingguanActive = false;

            this.selectedDate = new Date().toISOString().substr(0, 10); // set default today

            this.GetListReport(); // load data immediately
        },

        activateMingguan() {
            this.activeFilter = "mingguan";
            this.isBulananActive = false;
            this.isMingguanActive = true;

            this.initWeek();
            this.GetListReport(); // fetch weekly data
        },

        activateBulanan() {
            this.activeFilter = "bulanan";
            this.isBulananActive = true;
            this.isMingguanActive = false;

            this.GetListReport(); // fetch monthly data
        },

        activateTahun() {
            this.activeFilter = "tahun";
            this.isBulananActive = false;
            this.isMingguanActive = false;

            this.GetListReport(); // fetch yearly data
        },

        activateCustom() {
            this.activeFilter = "custom";
            this.isBulananActive = false;
            this.isMingguanActive = false;

            // Default: last 7 days
            const today = new Date();
            const lastWeek = new Date();
            lastWeek.setDate(today.getDate() - 7);

            this.startDate = lastWeek.toISOString().substr(0, 10);
            this.endDate = today.toISOString().substr(0, 10);

            this.GetListReport(); // auto load immediately
        },
        generateYearList() {
            const currentYear = new Date().getFullYear();
            this.yearList = [currentYear, currentYear - 1];
        }

    }
};
</script>
  
<style scoped>
.sales-report-page {
    background: #f7f7f7;
    min-height: 100vh;
}

.page-title {
    font-weight: 600;
}

.card-wrapper {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.time-filter .btn {
    border-radius: 20px;
    min-width: 120px;
}

.chart-box {
    height: 450px;
}

.chart-box {
    height: 450px;
    position: relative;
    width: 100%;
    overflow: hidden;
}

.chart-box canvas {
    width: 100% !important;
    height: 100% !important;
}

/* --- NEW STYLES FOR PASSWORD POPUP --- */
.password-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050; /* Above other content */
}

.password-modal {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.text-danger {
    color: #dc3545;
}
/* -------------------------------------- */
</style>